/**
 * The green drop line. `indented` marks a drop INSIDE a group's children;
 * `nested` deepens the indent to a nested room folder's child level, so a
 * drop INTO a folder is visually distinct from a drop UNDER it (both lines
 * otherwise sit at the same x and read identically).
 */
export const DropIndicatorLine: React.FC<{ indented?: boolean; nested?: boolean }> = ({ indented, nested }) => (
  <div className={`relative z-10 h-0${indented ? '' : ' w-full'}`}>
    <div className={`absolute inset-x-0 h-0.5 bg-neon-green-300${indented ? (nested ? ' ml-[5.5rem]' : ' ml-14') : ''}`} />
  </div>
);
